const questionnaireBr = {
  sections: [
    {
      id: 'what_is_wareclouds',
      part: 1,
      videoId: 'DUGVB99YTIk',
      questions: [
        {
          globalId: '1-1',
          question: 'O que a Wareclouds faz?',
          alternatives: [
            { option: 1, text: 'Vende produtos online para clientes finais.' },
            {
              option: 2,
              text: 'Ativa micro centros logísticos nas casas das pessoas.',
            },
            {
              option: 3,
              text: 'Oferece cursos de logística para empresas.',
            },
            { option: 4, text: 'Transporte internacional' },
          ],
          correctOption: 2,
        },
        {
          globalId: '1-2',
          question: 'Qual é o papel principal dos Clouders?',
          alternatives: [
            { option: 1, text: 'Embalar os produtos nos armazéns' },
            {
              option: 2,
              text: 'Levar os produtos dos micro centros logísticos nas casas até os clientes finais.',
            },
            {
              option: 3,
              text: 'Coordenar a logística entre fornecedores e armazéns',
            },
            {
              option: 4,
              text: 'Cadastrar novos clientes na plataforma',
            },
          ],
          correctOption: 2,
        },
      ],
    },
    {
      id: 'about_being_clouder',
      part: 2,
      videoId: 'X1pa7Pw9frI',
      questions: [
        {
          globalId: '2-1',
          question: 'A que horas começa a publicação diária das rotas?',
          alternatives: [
            { option: 1, text: '08:45 am' },
            { option: 2, text: '9:00 am' },
            { option: 3, text: '10:00 am' },
            { option: 4, text: '8:30 am' },
          ],
          correctOption: 3,
        },
        {
          globalId: '2-2',
          question: 'Até que horas as entregas devem ser realizadas?',
          alternatives: [
            { option: 1, text: '19h' },
            { option: 2, text: '20h' },
            { option: 3, text: '23h' },
            { option: 4, text: '21h' },
          ],
          correctOption: 3,
        },
        {
          globalId: '2-3',
          question: 'Quais fatores determinam o pagamento de uma rota?',
          alternatives: [
            { option: 1, text: 'Carro utilizado' },
            { option: 2, text: 'Distância percorrida' },
            { option: 3, text: 'Quantidade de devoluções entregues' },
            {
              option: 4,
              text: 'Quantas rotas ficam disponíveis no dia',
            },
          ],
          correctOption: 2,
        },
      ],
    },
    {
      id: 'pickup_and_delivery',
      part: 3,
      videoId: 'FsW9YEKsTtg',
      questions: [
        {
          globalId: '3-1',
          question:
            'O que você deve fazer primeiro ao chegar na armazenista para retirar seus pedidos?',
          alternatives: [
            {
              option: 1,
              text: 'Verificar no app se os pedidos estão em cinza',
            },
            {
              option: 2,
              text: 'Marcar todos os pedidos como entregues no app',
            },
            {
              option: 3,
              text: 'Apresentar-se informando seu nome e a cidade onde fará as entregas',
            },
            { option: 4, text: 'Otimizar sua rota' },
          ],
          correctOption: 3,
        },
        {
          globalId: '3-2',
          question: 'O que você deve fazer ao chegar na casa do cliente?',
          alternatives: [
            { option: 1, text: 'Entregar o pedido ao vizinho' },
            {
              option: 2,
              text: 'Ligar para o cliente, tocar a campainha ou o interfone caso ele não atenda',
            },
            {
              option: 3,
              text: 'Ir diretamente para o apartamento',
            },
            {
              option: 4,
              text: 'Aguardar 5 minutos e marcar como entregue',
            },
          ],
          correctOption: 2,
        },
        {
          globalId: '3-3',
          question:
            'Qual ação NÃO faz parte do processo de entrega ao cliente?',
          alternatives: [
            {
              option: 1,
              text: 'Ligar para o cliente e se não atender tocar a campainha',
            },
            {
              option: 2,
              text: 'Tirar foto do pacote no local de entrega',
            },
            {
              option: 3,
              text: 'Deixar o pedido com o vizinho sem autorização',
            },
            {
              option: 4,
              text: 'Registrar o nome da pessoa que recebeu no campo de comentários',
            },
          ],
          correctOption: 3,
        },
        {
          globalId: '3-4',
          question:
            'Se não for possível entregar um pedido, qual procedimento correto você deve seguir?',
          alternatives: [
            {
              option: 1,
              text: 'Marcar como "entregue" no app e seguir para o próximo pedido',
            },
            {
              option: 2,
              text: 'Deixar o pacote na portaria do prédio sem tirar foto',
            },
            {
              option: 3,
              text: 'Ligar duas vezes para o cliente, tirar foto de evidência e marcar como "não entregue" no app',
            },
            {
              option: 4,
              text: 'Ignorar o pedido e não registrar nada na plataforma',
            },
          ],
          correctOption: 3,
        },
      ],
    },
    {
      id: 'returns',
      part: 4,
      videoId: 'neAcvHzGgFY',
      questions: [
        {
          globalId: '4-1',
          question:
            'Qual é o prazo para devolver um pedido que não foi possível entregar?',
          alternatives: [
            { option: 1, text: 'No mesmo dia, antes das 18h' },
            { option: 2, text: 'Em até 48 horas' },
            { option: 3, text: 'Até o dia seguinte às 10h' },
            { option: 4, text: 'Após concluir todas as suas rotas' },
          ],
          correctOption: 3,
        },
        {
          globalId: '4-2',
          question:
            'Quem deve confirmar a marcação da devolução na plataforma antes de você sair da armazenista?',
          alternatives: [
            {
              option: 1,
              text: 'Somente o Clouder, marcando no app',
            },
            {
              option: 2,
              text: 'Somente o operador da Warecloud, marcando na plataforma',
            },
            {
              option: 3,
              text: 'Não é necessário confirmação, a devolução é automática',
            },
            {
              option: 4,
              text: 'Tanto o operador da Warecloud quanto o Clouder, cada um em sua plataforma',
            },
          ],
          correctOption: 4,
        },
      ],
    },
    {
      id: 'main_rules',
      part: 5,
      videoId: 'wVd8gpgzSzw',
      questions: [
        {
          globalId: '5-1',
          question: 'Quando o pagamento é feito?',
          alternatives: [
            { option: 1, text: 'Quinzenalmente' },
            { option: 2, text: 'Mensalmente' },
            { option: 3, text: 'Diário' },
            { option: 4, text: 'Semanal' },
          ],
          correctOption: 1,
        },
        {
          globalId: '5-2',
          question: 'Quais são os benefícios de subir de categoria?',
          alternatives: [
            { option: 1, text: 'Eles te dão uma medalha' },
            { option: 2, text: 'Você pode escolher seus horários' },
            {
              option: 3,
              text: 'Você tem acesso a melhores bônus e benefícios extras',
            },
            {
              option: 4,
              text: 'Não é necessário emitir nota fiscal',
            },
          ],
          correctOption: 3,
        },
        {
          globalId: '5-3',
          question:
            'Como você deve acionar o suporte em caso de problema com um pedido, entrega ou problema de faturamento?',
          alternatives: [
            {
              option: 1,
              text: 'Enviar e-mail para o gerente do armazém',
            },
            {
              option: 2,
              text: 'Marcar o pedido como "não entregue" e aguardar retorno',
            },
            {
              option: 3,
              text: 'Ligar para o cliente e informar o problema',
            },
            {
              option: 4,
              text: 'Abrir um chamado diretamente na plataforma',
            },
          ],
          correctOption: 4,
        },
      ],
    },
  ],
};

export default questionnaireBr;
